import { Input } from "components/Form/components/Input/Input";
import PropTypes from "prop-types";

export const Email = ({ input, meta, fieldProps, fieldAttr }) => (
    <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
        <input
            id={input.name}
            {...input}
            {...fieldAttr}
            aria-label={`${input.name}`}
            type="email"
            className="input__field"
        />
    </Input>
);
Email.defaultProps = {
    fieldProps: {},
    fieldAttr: {},
    input: {},
    meta: {},
};
Email.propTypes = {
    fieldProps: PropTypes.oneOfType([PropTypes.object]),
    fieldAttr: PropTypes.oneOfType([PropTypes.object]),
    input: PropTypes.oneOfType([PropTypes.object]),
    meta: PropTypes.oneOfType([PropTypes.object]),
};
